const pixel = () => {
  if (!window.fbq) {
    return
  }

  window.fbq('track', 'PageView')
}

export default pixel



// WEBPACK FOOTER //
// ./src/router/pixel.js